import { html } from 'lit';
import { FileText } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-file-text')
export class PdsIconFileText extends PdsIcon {
  @state()
  icon = FileText;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
